/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiKeyScope } from './ApiKeyScope';
import {
    ApiKeyScopeFromJSON,
    ApiKeyScopeFromJSONTyped,
    ApiKeyScopeToJSON,
    ApiKeyScopeToJSONTyped,
} from './ApiKeyScope';

/**
 * 
 * @export
 * @interface ApiKey
 */
export interface ApiKey {
    /**
     * 
     * @type {number}
     * @memberof ApiKey
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof ApiKey
     */
    userId: number;
    /**
     * 
     * @type {number}
     * @memberof ApiKey
     */
    companyId: number;
    /**
     * 
     * @type {string}
     * @memberof ApiKey
     */
    name: string;
    /**
     * First characters of the key for identification (the full key is never returned again)
     * @type {string}
     * @memberof ApiKey
     */
    keyPrefix: string;
    /**
     * 
     * @type {Array<ApiKeyScope>}
     * @memberof ApiKey
     */
    scopes: Array<ApiKeyScope>;
    /**
     * 
     * @type {Date}
     * @memberof ApiKey
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof ApiKey
     */
    lastUsedAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof ApiKey
     */
    revokedAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof ApiKey
     */
    expiresAt?: Date | null;
}

/**
 * Check if a given object implements the ApiKey interface.
 */
export function instanceOfApiKey(value: object): value is ApiKey {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('keyPrefix' in value) || value['keyPrefix'] === undefined) return false;
    if (!('scopes' in value) || value['scopes'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function ApiKeyFromJSON(json: any): ApiKey {
    return ApiKeyFromJSONTyped(json, false);
}

export function ApiKeyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiKey {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'userId': json['userId'],
        'companyId': json['companyId'],
        'name': json['name'],
        'keyPrefix': json['keyPrefix'],
        'scopes': ((json['scopes'] as Array<any>).map(ApiKeyScopeFromJSON)),
        'createdAt': (new Date(json['createdAt'])),
        'lastUsedAt': json['lastUsedAt'] == null ? undefined : (new Date(json['lastUsedAt'])),
        'revokedAt': json['revokedAt'] == null ? undefined : (new Date(json['revokedAt'])),
        'expiresAt': json['expiresAt'] == null ? undefined : (new Date(json['expiresAt'])),
    };
}

export function ApiKeyToJSON(json: any): ApiKey {
    return ApiKeyToJSONTyped(json, false);
}

export function ApiKeyToJSONTyped(value?: ApiKey | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'userId': value['userId'],
        'companyId': value['companyId'],
        'name': value['name'],
        'keyPrefix': value['keyPrefix'],
        'scopes': ((value['scopes'] as Array<any>).map(ApiKeyScopeToJSON)),
        'createdAt': ((value['createdAt']).toISOString()),
        'lastUsedAt': value['lastUsedAt'] == null ? undefined : ((value['lastUsedAt'] as any).toISOString()),
        'revokedAt': value['revokedAt'] == null ? undefined : ((value['revokedAt'] as any).toISOString()),
        'expiresAt': value['expiresAt'] == null ? undefined : ((value['expiresAt'] as any).toISOString()),
    };
}

